import { MessageService, SelectItem } from 'primeng/api';
import { Subject, switchMap, forkJoin } from 'rxjs';
import { map } from 'rxjs';

import { DatePipe, formatDate } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';

import { ProgressService } from 'src/app/services/progress.service';
import {
  CompetitorsListFilterSelectorService,
  CompetitorsListFiltersEnum,
} from '../competitors-list-filter-selector/competitors-list-filter-selector.service';
import { MarkReturnedSensorsService } from './mark-returned-sensors/mark-returned-sensors.service';
import { CloudFile } from 'src/app/models/cloudFile';
import { Race } from 'src/app/models/race';
import { RaceClass } from 'src/app/models/race-class';
import { Registration } from 'src/app/models/registration';
import { RaceRefreshObject, UnsuccessRegistration, OverallResultItem } from 'src/app/models';
import { SelectItemService } from '../select-item/select-item.service';
import { SettingsService } from 'src/app/services/settings.service';
import { StimulsoftLoaderService } from 'src/app/services/stimulsoft-loader.service';
import { CommonService } from 'src/app/services/common.service';
import { TimePeriodPipe } from 'src/app/pipes/time-period.pipe';
import { DataOvervallReport } from 'src/app/models/data-overvall-report';
import { CompetitorInfo } from 'src/app/models/competitor-info';
import { Hof } from 'src/app/models/hof';
import { UserDomainService } from 'src/app/domains/user.service';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class DocumentsComponent implements OnInit, OnChanges {
  @Input() selectedRace!: Race;
  @Input() raceClasses: RaceClass[] = [];
  @Input() selectedClass!: RaceClass;
  _participants: Registration[] = [];
  subscriptionGet: any;
  @Input() set participants(arr: Registration[]) {
    this._participants = arr;
  }
  get participants(): Registration[] {
    const participants: Registration[] = [];
    this.selectedClasses.forEach((selectedClass) => {
      selectedClass.registrations.forEach((participant) => (participant.className = selectedClass.name));
      participants.push(...selectedClass.registrations);
    });

    return participants;
  }

  allClass: RaceClass = new RaceClass({
    name: this.appSettings.translate[this.appSettings.selectedLang]['header_all'],
    clUid: 'ALL',
  });

  @Output() refreshEvent: EventEmitter<RaceRefreshObject> = new EventEmitter();
  visibleOvervalResultDialog = false;
  displayPreview = false;
  displayObj: any;
  displayMrt!: string;
  selectedClasses: RaceClass[] = [];
  filter: string = '';

  format = 'dd MMMM yyyy';

  maxSmsLength: number = 267;
  oneSmsLength: number = 70; // Количество символов в одном SMS на русском
  manySmsLength: number = 67; // Количество символов в одном SMS на русском если текст не умещается в 1 смс
  smsText: string = '';
  smsPrice: number = 5;

  raceStates: SelectItem[];
  raceState: any;

  activeIndex: number = 0;

  addCompetitorDialog: boolean = false;

  timeFormat: string = 'HH:mm:ss';

  unsuccessRegistrations: UnsuccessRegistration[] = [];

  sportSubType: string = '';
  participantToPrintLicense: Registration | null = null;
  dialogSportSubType: boolean = false;
  isStimulsoftLoading: boolean = true;

  totals = {
    competitors: 0,
    fee: 0,
    gpsTrackers: 0,
    chronoTags: 0,
  };

  showModalForCompetitorInfo = false;
  dataModalForCompetitorInfo: CompetitorInfo | null = null;

  private getInfoCompInitiator: Subject<Registration['user']['cUid']> = new Subject();
  private patchInfoCompInitiator: Subject<CompetitorInfo> = new Subject();

  constructor(
    public progressService: ProgressService,
    public messageService: MessageService,
    public appSettings: SettingsService,
    private competitorsListFilterSelector: CompetitorsListFilterSelectorService,
    private timePeriodPipe: TimePeriodPipe,
    private datePipe: DatePipe,
    private markReturnedSensorsService: MarkReturnedSensorsService,
    private selectItemService: SelectItemService,
    private commonService: CommonService,
    private stimulsoftLoader: StimulsoftLoaderService,
    private userDomainService: UserDomainService,
    private cdr: ChangeDetectorRef
  ) {
    this.raceStates = [
      { label: '0', value: 0 },
      { label: '1', value: 1 },
      { label: '2', value: 2 },
      { label: '3', value: 3 },
    ];
    this.raceState = { label: '0', value: 0 };
    this.stimulsoftLoader.loadStimulsoft().finally(() => {
      this.isStimulsoftLoading = false;
    });
    this.subscribeToGet();
    this.subscribeToPatch();
  }

  //
  //
  //
  // -------------------------------   ИНИЦИАЛИЗАЦИЯ И ЗАГРУЗКА ДАННЫХ ---------------------------------------------------------------------

  public ngOnInit() {
    this.raceClasses.unshift(this.allClass);
    this.progressService.refreshTableData.subscribe(() => {
      // this.fillTables();
      this.calculateTotals();
    });
    if (this.selectedRace && this.selectedRace.showMillsInResults) this.timeFormat = 'HH:mm:ss.SSS';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedClass']) {
      this.raceState = this.selectedRace.raceState;
      this.fillTables();
    }
    // if (changes['raceClasses'] && !changes['raceClasses'].firstChange) {
    //   this.fillTables();
    // }
  }

  // Обновить таблицы при нажатии на кнопку Обновить рядом с названием класса
  refresh(selectClass: RaceClass) {
    this.refreshEvent.emit({
      selectedRace: this.selectedRace,
      raceClasses: this.raceClasses,
      selectedClassUid: selectClass.clUid,
      selectedFilter: this.competitorsListFilterSelector.getSelectedCompetitorsListFilter(),
    });
  }

  // Обновить таблицы при смене фильтра
  refreshByFilter(selectFilter: CompetitorsListFiltersEnum) {
    this.filter = selectFilter.toString();
    this.refreshEvent.emit({
      selectedRace: this.selectedRace,
      raceClasses: this.raceClasses,
      selectedClassUid: this.selectedClass.clUid,
      selectedFilter: selectFilter,
    });
  }

  // Заполнение таблиц участников выбранного класса или всех
  fillTables() {
    this.selectedClasses = this.selectedClass.clUid == 'ALL' ? this.raceClasses.slice(1) : [this.selectedClass];
  }

  calculateTotals() {
    this.totals = this.raceClasses.reduce(
      (acc, classData) => {
        const participants = classData.registrations || [];

        return participants.reduce((classAcc, participant) => {
          classAcc.competitors += 1 + (participant.crew ? participant.crew.length : 0);
          classAcc.fee += Number(participant.startFee);

          if (participant.gpsTracker) classAcc.gpsTrackers += 1;
          if (participant.chronoTag) classAcc.chronoTags += 1;
          return classAcc;
        }, acc);
      },
      {
        competitors: 0,
        fee: 0,
        gpsTrackers: 0,
        chronoTags: 0,
      }
    );
  }

  onTabChange(event: any) {
    this.activeIndex = event.index; // Update activeIndex on tab change
  }

  //
  //
  //
  // -------------------------------   СОСТОЯНИЕ СОРЕВНОВАНИЯ ---------------------------------------------------------------------

  // Запрос на изменение состояния соревнования
  queryChangeRaceState(event: SelectItem) {
    if (event.value === 3) {
      this.commonService.confirm({
        message: this.appSettings.getTranslate('close_race_confirm'),
        header: this.appSettings.translate[this.appSettings.selectedLang]['sms_confirm_header'],
        icon: 'pi pi-info-circle',
        accept: () => {
          this.changeRaceState(event.value);
        },
        reject: () => {
          this.raceState = this.selectedRace.raceState;
        },
      });
    } else {
      this.changeRaceState(event.value);
    }
  }

  // Изменение состояния соревнования
  changeRaceState(state) {
    this.progressService
      .changeRaceState(this.selectedRace, state)
      .then((response) => {
        if (response) {
          const raceState = Number(response.data);
          this.raceState = raceState;
          this.selectedRace.raceState = raceState;
        }
      });
  }

  //
  //
  //
  // -------------------------------   ПРИСВОЕНИЕ/УДАЛЕНИЕ НОМЕРОВ УЧАСТНИКОВ ---------------------------------------------------------------------

  // Открыть диалог способа присвоения номеров
  dialogAssignNumbers() {
    const variants = [
      {
        type: 'within_class',
        label: this.appSettings.translate[this.appSettings.selectedLang]['assign_numbers_within_class'],
      },
      {
        type: 'across_all',
        label: this.appSettings.translate[this.appSettings.selectedLang]['assign_numbers_across_all'],
      },
    ];

    return this.selectItemService
      .selectItem(this.appSettings.translate[this.appSettings.selectedLang]['assign_numbers'], variants)
      .onClose.subscribe((variant: any) => {
        this.assignNumbers(variant.type);
      });
  }

  // Присвоить номера выбранным способом
  assignNumbers(variant: 'within_class' | 'across_all') {
    this.progressService
      .assignNumbers(this.selectedRace.rUid, this.selectedClass.clUid, variant)
      .then(() => {
        this.progressService.refreshTableData.emit(this.selectedClass.clUid);
        this.messageService.add({
          severity: 'info',
          summary: this.appSettings.translate[this.appSettings.selectedLang]['numbers_assigned'],
        });
      });
  }

  // Удалить номера
  deleteNumbers() {
    this.commonService.confirm({
      message: this.appSettings.translate[this.appSettings.selectedLang]['delete_numbers_confirm'],
      header: this.appSettings.translate[this.appSettings.selectedLang]['delete_numbers'],
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.progressService
          .deleteNumbers(this.selectedRace.rUid, this.selectedClass.clUid)
          .then(() => {
            this.progressService.refreshTableData.emit(this.selectedClass.clUid);
            this.messageService.add({
              severity: 'info',
              summary: this.appSettings.translate[this.appSettings.selectedLang]['numbers_deleted'],
            });
          });
      },
      reject: () => { },
    });
  }

  //
  //
  //
  // -------------------------------   ПЕЧАТЬ ПРОТОКОЛОВ ---------------------------------------------------------------------

  // Печатает сокращенный список регистрации
  printRegistrationsListShort() {
    const object: {
      race: any;
      users: {
        number: number;
        name: string;
        city: string;
        sport_title: string;
      }[]
    } = {
      race: {
        name: this.selectedRace.name,
        date: formatDate(this.selectedRace.date, this.format, 'ru-ru'),
        city: this.selectedRace.city.address,
        cls: this.selectedClass.name,
        leftImage: this.getImgSrc('protocolsLogoLeft'),
        centerImage: this.getImgSrc('protocolsLogoCenter'),
        rightImage: this.getImgSrc('protocolsLogoRight'),
        translation_report_title: this.appSettings.getTranslate('report_competitors_list_full'),
        translation_col_competitor_name: this.appSettings.getTranslate('report_competitor_name'),
        translation_col_city: this.appSettings.getTranslate('report_city'),
        translation_col_sport_title: this.appSettings.getTranslate('report_sport_title'),
        translation_col_insurance: this.appSettings.getTranslate('report_insurance_no_summ'),
        translation_col_sport_license: this.appSettings.getTranslate('report_sport_license'),
        translation_col_competitor_signature: this.appSettings.getTranslate('report_competitor_signature'),
        translation_report_main_org: this.appSettings.getTranslate('report_main_org'),
      },
      users: [],
    };

    let num = 1;
    this.participants.forEach((item) => {
      const user = {
        number: num,
        name: item.user.name,
        city: item.user.city.split(',').join(',\r\n'),
        sport_title: item.user.sportTitle,
      };
      object.users.push(user);
      num = num + 1;
    });

    this.displayPreview = true;
    this.displayObj = object;
    this.displayMrt = `assets/report_reg_card.mrt?random=${Math.random()}`;
    this.cdr.markForCheck();
  }

  // Печатает список регистрации со всеми данными
  printRegistrationsListFull(csv: boolean = false) {
    const object: { race: any, users: any } = {
      race: {
        city: this.selectedRace.city.address,
        name: this.selectedRace.name,
        date: formatDate(this.selectedRace.date, this.format, 'ru-ru'),
        cls: this.selectedClass.name,
        leftImage: this.getImgSrc('protocolsLogoLeft'),
        centerImage: this.getImgSrc('protocolsLogoCenter'),
        rightImage: this.getImgSrc('protocolsLogoRight'),
        info_field_name: this.selectedRace.infoFieldName.split(',').join(',\r\n'),
        translation_report_title: this.appSettings.getTranslate('report_competitors_list_full'),
        translation_col_bib: this.appSettings.getTranslate('report_bib'),
        translation_col_competitor_name: this.appSettings.getTranslate('report_competitor_name'),
        translation_col_competitor_birth_date: this.appSettings.getTranslate('report_competitor_birth_date'),
        translation_col_team: this.appSettings.getTranslate('report_team'),
        translation_col_city: this.appSettings.getTranslate('report_city'),
        translation_col_phone: this.appSettings.getTranslate('report_phone'),
        translation_col_email: this.appSettings.getTranslate('report_email'),
        translation_col_starting_fee: this.appSettings.getTranslate('report_starting_fee'),
        translation_col_reg_confirmed: this.appSettings.getTranslate('report_reg_confirmed'),
        translation_col_reg_time: this.appSettings.getTranslate('report_reg_time'),
        translation_col_class: this.appSettings.getTranslate('report_class'),
        translation_report_main_org: this.appSettings.getTranslate('report_main_org'),
      },
      users: [],
    };

    let num = 1;
    this.selectedClasses.forEach((classData) => {
      classData.registrations.forEach((item) => {
        const regDateTime = this.datePipe.transform(item.registrationTime, 'dd.MM.yyyy HH:mm:ss', this.selectedRace.offset);
        if (!regDateTime) {
          return;
        }
        const [regDate, regTime] = regDateTime.split(' ');

        const user = {
          num,
          name: item.user.name,
          international_name: item.user.internationalName,
          citizenship: item.user.citizenship,
          sport_title: item.user.sportTitle,
          gender: this.appSettings.genders[item.user.gender].label,
          city: item.user.city.split(',').join(',\r\n'),
          birthday: `${item.user.birthdate.getDate().toString().padStart(2, '0')}.${(item.user.birthdate.getMonth() + 1).toString().padStart(2, '0')}.${item.user.birthdate.getFullYear()}`,
          phone: item.user.phone,
          email: item.user.email,
          team: item.user.team,
          info: item.info,
          starting_fee: item.startFee,
          start_number: item.startNumber,
          confirmed: item.allDocumentsValid ? 'V' : '',
          className: classData.name,
          regDate,
          regTime,
          regNum: item.registrationTime.getTime(),
          orgComment: item.orgComment,
        };
        object.users.push(user);
        num = num + 1;
      });
    });

    object.users.sort((a, b) => {
      if (a.regNum > b.regNum) return 1;
      if (a.regNum < b.regNum) return -1;
      return 0;
    });

    if (csv) {
      let csvText = `${object.race.name}\r\n`;
      csvText += `${object.race.date}\r\n`;
      csvText += `${object.race.city}\r\n`;
      csvText += `${object.race.cls}\r\n`;
      csvText += `\r\n`;
      object.users.forEach((user) => {
        csvText += `${user.className};${user.name};${user.city.split(',\r\n').join(',')};${user.sport_title};${user.start_number};${user.birthday};${user.team};${user.international_name.replace(/[\r\n]+/g, '')};${user.citizenship};${user.gender};${user.phone};${user.email};${user.info};${user.starting_fee};${user.confirmed};${user.regDate} ${user.regTime};${user.orgComment}\r\n`;
      });
      this.downloadCSV(csvText.replace(/&nbsp;/g, '').replace(/undefined/g, ''), "registrations_list");
    } else {
      this.displayPreview = true;
      this.displayObj = object;
      this.displayMrt = `assets/report_reg_user_card.mrt?random=${Math.random()}`;
      this.cdr.markForCheck();
    }
  }

  async downloadPollResultsCsv() {
    const pollResults = await this.progressService.getPollResults(this.selectedRace.rUid);

    let csvText = `${pollResults.raceName}\r\n`;
    csvText += `${pollResults.raceDate}\r\n`;
    csvText += `${pollResults.raceCity}\r\n`;
    csvText += `\r\n`;

    csvText += `Класс;Номер;Имя;Город;Телефон`;
    pollResults.questions.forEach((question) => {
      csvText += `;${question}`;
    });
    csvText += `\r\n`;

    pollResults.competitors.forEach((competitor) => {
      csvText += `${competitor.className};${competitor.number};${competitor.userName};${competitor.userCity};${competitor.userPhone}`;
      competitor.answers.forEach((answer) => {
        csvText += `;${answer}`;
      });
      csvText += `\r\n`;
    });
    this.downloadCSV(csvText.replace(/&nbsp;/g, '').replace(/undefined/g, ''), "poll_results");
  }

  // Выгрузка CSV со списком участия в 10 последних гонках каждого участника текущей гонки
  downloadParticipationInRacesCsv() {
    const participants = this.participants;

    if (participants.length === 0) {
      this.messageService.add({
        severity: 'info',
        summary: this.appSettings.translate[this.appSettings.selectedLang]['no_data'] || 'Нет данных',
      });
      return;
    }

    this.messageService.add({
      severity: 'info',
      summary: this.appSettings.translate[this.appSettings.selectedLang]['loadingDataReport'],
    });

    // Уникальные cUid участников (включая экипаж)
    const cUids = [...new Set(participants.map((p) => p.user.cUid))];

    // Запрашиваем зал славы для каждого участника
    const hofRequests = cUids.map((cUid) =>
      this.userDomainService.getHof(cUid).pipe(map((hofs) => ({ cUid, hofs: hofs || [] })))
    );

    forkJoin(hofRequests).subscribe({
      next: (results) => {
        const hofMap = new Map<string, Hof[]>();
        results.forEach((r) => hofMap.set(r.cUid, r.hofs));

        let csvText = `${this.selectedRace.name}\r\n`;
        csvText += `${formatDate(this.selectedRace.date, this.format, 'ru-ru')}\r\n`;
        csvText += `${this.selectedRace.city.address}\r\n`;
        csvText += `${this.selectedClass.name}\r\n`;
        csvText += `\r\n`;
        csvText += `Участник;Класс;Город;Название гонки;Дата;Класс в гонке;Место;Кол-во участников\r\n`;

        participants.forEach((participant) => {
          const hofs = hofMap.get(participant.user.cUid) || [];
          // Сортируем по дате убыванию, берём последние 10 гонок
          const last10 = [...hofs]
            .sort((a, b) => {
              const da = new Date(a.date).getTime();
              const db = new Date(b.date).getTime();
              return db - da;
            })
            .slice(0, 10);

          if (last10.length === 0) {
            csvText += `${participant.user.name};${participant.className};${participant.user.city};—\r\n`;
            return;
          }

          last10.forEach((hof) => {
            csvText += `${participant.user.name};${participant.className};${participant.user.city};${hof.name};${hof.date};${hof.className};${hof.position};${hof.competitors}\r\n`;
          });
        });

        this.downloadCSV(csvText.replace(/&nbsp;/g, '').replace(/undefined/g, ''), 'participation_in_races');
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: this.appSettings.translate[this.appSettings.selectedLang]['error'],
          detail: err.message,
        });
      },
    });
  }

  // Печать протокола техосмотра
  printTechCheckProtocol() {
    const object: any = {
      race: {
        city: this.selectedRace.city.address,
        name: this.selectedRace.name,
        date: formatDate(this.selectedRace.date, this.format, 'ru-ru'),
        cls: this.selectedClass.name,
        leftImage: this.getImgSrc('protocolsLogoLeft'),
        centerImage: this.getImgSrc('protocolsLogoCenter'),
        rightImage: this.getImgSrc('protocolsLogoRight'),
        info_field_name: this.selectedRace.infoFieldName.split(',').join(',\r\n'),
        translation_report_title: this.appSettings.getTranslate('report_tech_committee'),
        translation_col_bib: this.appSettings.getTranslate('report_bib'),
        translation_col_competitor_name: this.appSettings.getTranslate('report_competitor_name'),
        translation_col_team_city: this.appSettings.getTranslate('report_team_city'),
        translation_col_tech_confirm: this.appSettings.getTranslate('report_tech_confirm'),
        translation_report_main_judge: this.appSettings.getTranslate('report_main_judge'),
        translation_report_main_tech: this.appSettings.getTranslate('report_main_tech'),
      },
      users: [],
    };

    let num = 1;
    this.participants.forEach((item) => {
      let techMark: string | null = '';
      if (item.techMark) {
        techMark = this.datePipe.transform(item.techMark, 'dd.MM.yyyy HH:mm:ss', this.selectedRace.offset);
      };
      const user = {
        number: num,
        name: item.user.name,
        city: item.user.city.split(',').join(',\r\n'),
        team: item.user.team,
        start_number: item.startNumber,
        info: item.info,
        techMark: item.techMark,
        techComment: item.techComment,
      };
      object.users.push(user);
      num = num + 1;
    });

    this.displayPreview = true;
    this.displayObj = object;
    this.displayMrt = `assets/report_texcom_card.mrt?random=${Math.random()}`;
    this.cdr.markForCheck();
  }

  // Печать медицинского протокола
  printMedicalProtocol() {
    const object: any = {
      race: {
        city: this.selectedRace.city.address,
        name: this.selectedRace.name,
        date: formatDate(this.selectedRace.date, this.format, 'ru-ru'),
        cls: this.selectedClass.name,
        leftImage: this.getImgSrc('protocolsLogoLeft'),
        centerImage: this.getImgSrc('protocolsLogoCenter'),
        rightImage: this.getImgSrc('protocolsLogoRight'),
        translation_report_title: this.appSettings.getTranslate('report_medical_committee'),
        translation_col_bib: this.appSettings.getTranslate('report_bib'),
        translation_col_competitor_name: this.appSettings.getTranslate('report_competitor_name'),
        translation_col_team_city: this.appSettings.getTranslate('report_team_city'),
        translation_col_blood_pressure: this.appSettings.getTranslate('report_blood_pessure'),
        translation_report_main_medical: this.appSettings.getTranslate('report_main_medic'),
      },
      users: [],
    };

    let num = 1;
    this.participants.forEach((item) => {
      const user = {
        number: num,
        name: item.user.name,
        city: item.user.city.split(',').join(',\r\n'),
        team: item.user.team,
        start_number: item.startNumber,
      };
      object.users.push(user);
      num = num + 1;
    });

    this.displayPreview = true;
    this.displayObj = object;
    this.displayMrt = `assets/report_med_card.mrt?random=${Math.random()}`;
    this.cdr.markForCheck();
  }

  // Печать протокола допущенных
  printApprovedProtocol() {
    const object: any = {
      race: {
        city: this.selectedRace.city.address,
        name: this.selectedRace.name,
        date: formatDate(this.selectedRace.date, this.format, 'ru-ru'),
        cls: this.selectedClass.name,
        leftImage: this.getImgSrc('protocolsLogoLeft'),
        centerImage: this.getImgSrc('protocolsLogoCenter'),
        rightImage: this.getImgSrc('protocolsLogoRight'),
        translation_report_title: this.appSettings.getTranslate('report_admitted'),
        translation_col_bib: this.appSettings.getTranslate('report_bib'),
        translation_col_competitor_name: this.appSettings.getTranslate('report_competitor_name'),
        translation_col_team_city: this.appSettings.getTranslate('report_team_city'),
        translation_report_main_judge: this.appSettings.getTranslate('report_main_judge'),
      },
      users: [],
    };

    let num = 1;
    this.participants.forEach((item) => {
      const user = {
        number: num,
        name: item.user.name,
        city: item.user.city.split(',').join(',\r\n'),
        team: item.user.team,
        start_number: item.startNumber,
      };
      object.users.push(user);
      num = num + 1;
    });

    this.displayPreview = true;
    this.displayObj = object;
    this.displayMrt = `assets/report_access_card.mrt?random=${Math.random()}`;
    this.cdr.markForCheck();
  }

  // Печать списка выданных трекеров / датчиков хронометража
  async printIssuedDevicesList(deviceType: 'trackers' | 'tags') {
    const template = 'report_devices.mrt';
    const field1 = deviceType == 'trackers' ? 'gpsTracker' : 'chronoTag';
    const field2 = deviceType == 'trackers' ? 'trackerReturnedAt' : 'tagReturnedAt';

    const object: any = {
      race: {
        name: this.selectedRace.name,
        date: formatDate(this.selectedRace.date, this.format, 'ru-ru'),
        city: this.selectedRace.city.address,
        cls: this.selectedClass.name,
        total_devices: 0,
        leftImage: this.getImgSrc('protocolsLogoLeft'),
        centerImage: this.getImgSrc('protocolsLogoCenter'),
        rightImage: this.getImgSrc('protocolsLogoRight'),
        translation_report_title: deviceType == 'trackers' ? this.appSettings.getTranslate('report_trackers') : this.appSettings.getTranslate('report_tags'),
        translation_col_bib: this.appSettings.getTranslate('report_bib'),
        translation_col_competitor_name: this.appSettings.getTranslate('report_competitor_name'),
        translation_col_city: this.appSettings.getTranslate('report_city'),
        translation_col_phone: this.appSettings.getTranslate('report_phone'),
        translation_col_device: deviceType == 'trackers' ? this.appSettings.getTranslate('report_tracker') : this.appSettings.getTranslate('report_tag'),
        translation_col_device_returned: this.appSettings.getTranslate('report_device_returned'),
        translation_total_devices: this.appSettings.getTranslate('report_total_devices'),
        translation_report_main_tech: this.appSettings.getTranslate('report_main_tech'),
      },
      users: [],
    };

    let num = 1;
    const arr = this.participants.filter((item) => item[field1]);
    object.race.total_devices = arr.length;
    arr.forEach((item) => {
      const user = {
        number: num,
        start_number: item.startNumber,
        name: item.user.name,
        city: item.user.city,
        phone: item.user.phone,
        device_number: item[field1],
        device_returned: item[field2] ? this.datePipe.transform(item[field2], 'dd.MM.yyyy HH:mm:ss', this.selectedRace.offset) : '',
      };
      object.users.push(user);
      num = num + 1;
    });

    this.displayPreview = true;
    this.displayObj = object;
    this.displayMrt = `assets/${template}?random=${Math.random()}`;
    this.cdr.markForCheck();
  }

  // Печать протокола командного зачета
  async printTeamStandings() {
    const object: any = {
      race: {
        city: this.selectedRace.city.address,
        name: this.selectedRace.name,
        date: formatDate(this.selectedRace.date, this.format, 'ru-ru'),
        cls: 'Все',
        count_dev: 0,
        leftImage: this.getImgSrc('protocolsLogoLeft'),
        centerImage: this.getImgSrc('protocolsLogoCenter'),
        rightImage: this.getImgSrc('protocolsLogoRight'),
      },
      teamInfo: [],
    };

    const teamInfo = await this.progressService.getTeamResults(this.selectedRace.rUid, this.selectedClass.clUid);

    let num = 1;
    object.race.count_dev = teamInfo.length;
    teamInfo.forEach((item) => {
      const teamInfo = {
        number: num,
        nameTeam: item.name,
        competitors: '',
        raceTime: '',
        penalty: '',
        DNF: '',
      };
      let raceTime = 0;
      let penalty = 0;
      let DNF = false;
      item.competitors.forEach((user) => {
        teamInfo.competitors = `${user.user.name}, ${teamInfo.competitors}`;
        raceTime += user.raceTime;
        penalty += user.penalty * 1000;
        if (!DNF && (user.DNF || user.raceTime === 0)) {
          DNF = true;
        }
      });

      if (DNF) {
        teamInfo.DNF = this.appSettings.translate[this.appSettings.selectedLang]['team_dnf'];
      } else {
        teamInfo.DNF = this.appSettings.translate[this.appSettings.selectedLang]['team_finish'];
      }

      teamInfo.raceTime = this.timePeriodPipe.transform(raceTime, 'hh:mm:ss');
      teamInfo.penalty = this.timePeriodPipe.transform(penalty, 'HH:mm:ss');

      object.teamInfo.push(teamInfo);
      num = num + 1;
    });

    this.displayPreview = true;
    this.displayObj = object;
    this.displayMrt = `assets/report_team_results.mrt?random=${Math.random()}`;
  }

  // Печать протокола индивидуального зачета
  async printIndividualStandings(type: string = '') {
    const raceData: any = [];
    const overallClass: RaceClass = new RaceClass({
      clUid: 'OVERALL_STANDINGS',
      name: this.appSettings.translate[this.appSettings.selectedLang]['overall_standings'],
    });

    const classes = type == 'overall' ? [overallClass] : this.selectedClasses;

    for (const selectedClass of classes) {
      const result = await this.progressService.getPersonalResult(this.selectedRace, selectedClass);

      const classData: any = {
        city: this.selectedRace.city.address,
        name: this.selectedRace.name,
        left_image: this.getImgSrc('protocolsLogoLeft'),
        center_image: this.getImgSrc('protocolsLogoCenter'),
        right_image: this.getImgSrc('protocolsLogoRight'),
        date: formatDate(this.selectedRace.date, this.format, 'ru-ru'),
        info: this.selectedRace.infoFieldName.split(',').join(',\r\n'),
        class_name: selectedClass.name,
        report_rules: result[0] ? (result[0].byBestLap === '1' ? this.appSettings.getTranslate('report_rules_by_best_lap') : '') : '',
        translation_report_title: this.appSettings.getTranslate('report_personal_results'),
        translation_col_bib: this.appSettings.getTranslate('report_bib'),
        translation_col_competitor_name: this.appSettings.getTranslate('report_competitor_name'),
        translation_col_team_city: this.appSettings.getTranslate('report_team_city').split(',').join(',\r\n'),
        translation_col_time_start: this.appSettings.getTranslate('report_time_start'),
        translation_col_time_fin: this.appSettings.getTranslate('report_time_fin'),
        translation_col_time_race: result[0] ? (result[0].byBestLap === '1' ? this.appSettings.getTranslate('report_best_lap_time') : this.appSettings.getTranslate('report_time_race')) : this.appSettings.getTranslate('report_time_race'),
        translation_col_laps: this.appSettings.getTranslate('report_laps'),
        translation_report_main_judge: this.appSettings.getTranslate('report_main_judge'),
        translation_report_secretary: this.appSettings.getTranslate('report_secretary'),
        users: [],
      };

      let num = 1;
      result.forEach((item) => {
        item.team = item.team.trim();
        const user = {
          number: item.raceTime > 0 && item.dnf === 0 ? String(num) : '-',
          start_number: item.startNumber,
          name: item.name,
          city: item.city.split(',').join(',\r\n'),
          team: item.team.length ? item.team : '',
          info: item.info,
          start_time: item.startTime,
          end_time: item.endTime,
          race_time: this.timePeriodPipe.transform(item.raceTime, this.timeFormat),
          circles: item.circles,
        };
        classData.users.push(user);
        num = num + 1;
      });
      raceData.push(classData);
    }

    this.messageService.add({
      severity: 'info',
      summary: this.appSettings.translate[this.appSettings.selectedLang]['loadingDataReport'],
    });

    // setTimeout(() => {
      this.displayPreview = true;
      this.displayObj = raceData;
      this.displayMrt = `assets/report_personal_result.mrt?random=${Math.random()}`;
      this.cdr.markForCheck();
    // });
  }

  //
  //
  //
  // -------------------------------   ПЕЧАТЬ СВОДНОГО ПРОТОКОЛА ---------------------------------------------------------------------

  // Печать сводного протокола по нескольким заездам / гонкам
  printSummaryStandings(e) {
    const races = [e.selectedRace_1, e.selectedRace_2];

    if (e.selectedRace_3) {
      races.push(e.selectedRace_3);
    }
    if (e.selectedRace_4) {
      races.push(e.selectedRace_4);
    }
    if (e.selectedRace_5) {
      races.push(e.selectedRace_5);
    }
    if (e.selectedRace_6) {
      races.push(e.selectedRace_6);
    }

    this.progressService.getOverallResult(races, this.selectedClass, e.score.tableKey, e.scores_equal.equalScoresVariantKey).subscribe(
      (result) => {
        const classData = result.classes[0];

        let minRaceDate = this.selectedRace.date;
        let maxRaceDate = this.selectedRace.date;
        result.races.forEach((race) => {
          let raceDate = new Date(race.date);
          if (raceDate > maxRaceDate) maxRaceDate = raceDate;
          if (raceDate < minRaceDate) minRaceDate = raceDate;
        });
        let dateString = '';
        let raceCity = this.selectedRace.city.address;
        let raceName = this.selectedRace.name;
        let runTitle: string[] = [];
        for (let i = 1; i <= 6; i++) {
          runTitle[i] = `${i} ${this.appSettings.getTranslate('report_run')}`;
        }
        if (this.getDifferenceInDays(minRaceDate, maxRaceDate) > 2) {
          raceName = '';
          raceCity = '';
          let i = 1;
          result.races.forEach((race) => {
            runTitle[i] = `${race.name}\r\n${formatDate(race.date, this.format, 'ru-ru')}`;
            i++;
          });
        }

        if (minRaceDate !== maxRaceDate) dateString = `${formatDate(minRaceDate, this.format, 'ru-ru')} - ${formatDate(maxRaceDate, this.format, 'ru-ru')}`
        else dateString = formatDate(minRaceDate, this.format, 'ru-ru');
        let reportRules = this.appSettings.getTranslate('report_rules', [e.score.tableKey, e.scores_equal.equalScoresVariantName]);
        let pointsColumnTitle = this.appSettings.getTranslate('report_run_points');
        let totalPointsTitle = this.appSettings.getTranslate('report_total_points');
        if (result.timeOnly) {
          reportRules = this.appSettings.getTranslate('report_rules_by_time');
          totalPointsTitle = this.appSettings.getTranslate('report_total_time');
        }
        if (result.byBestLap) {
          reportRules = this.appSettings.getTranslate('report_rules_by_best_lap');
          totalPointsTitle = this.appSettings.getTranslate('report_best_lap_time');
        }
        if (result.byBestLap || result.timeOnly) pointsColumnTitle = this.appSettings.getTranslate('report_run_time');

        const object: any = {
          race: {
            city: raceCity,
            name: raceName,
            date: dateString,
            cls: classData.name,
            left_image: this.getImgSrc('protocolsLogoLeft'),
            center_image: this.getImgSrc('protocolsLogoCenter'),
            right_image: this.getImgSrc('protocolsLogoRight'),
            info: this.selectedRace.infoFieldName.split(',').join(',\r\n'),
            report_rules: reportRules,
            translation_report_title: this.appSettings.getTranslate('report_overall_results'),
            translation_col_position: this.appSettings.getTranslate('report_position'),
            translation_col_bib: this.appSettings.getTranslate('report_bib'),
            translation_col_competitor_name_team_city: this.appSettings.getTranslate('report_name_team_city').split(',').join(',\r\n'),
            translation_col_competitor_name: this.appSettings.getTranslate('report_competitor_name'),
            translation_col_team: this.appSettings.getTranslate('report_team'),
            translation_col_city: this.appSettings.getTranslate('report_city'),
            translation_col_run_1: runTitle[1],
            translation_col_run_2: runTitle[2],
            translation_col_run_3: runTitle[3],
            translation_col_run_4: runTitle[4],
            translation_col_run_5: runTitle[5],
            translation_col_run_6: runTitle[6],
            translation_col_run_position: this.appSettings.getTranslate('report_run_position'),
            translation_col_run_points: pointsColumnTitle,
            translation_col_total_points: totalPointsTitle,
            translation_report_main_judge: this.appSettings.getTranslate('report_main_judge'),
            translation_report_secretary: this.appSettings.getTranslate('report_secretary'),
          },
          users: [],
        };

        let num = 1;
        classData.competitors.forEach((item) => {
          let user: DataOvervallReport = {
            number: num++,
            start_number: item.number,
            team: item.team.length ? item.team : '',
            name: item.name.split('$').join('\r\n'),
            city: item.city,
            info: item.info,
            totalPoints: item.totalScores,
            position: item.place,
          };
          user = this.getLapsData(user, item.results);
          object.users.push(user);
        });

        if (e.csv) {
          let csvText = `${object.race.name}\r\n`;
          csvText += `${object.race.date}\r\n`;
          csvText += `${object.race.city}\r\n`;
          csvText += `${object.race.cls}\r\n`;
          csvText += `\r\n`;
          object.users.forEach((user) => {
            csvText += `${user.number}|${user.start_number}|${user.name}|${user.team}|${user.city.split(',\r\n').join(',')}|${user.info}|`;
            for (let i = 1; i <= races.length; i++) {
              csvText += `${user[`RacePosition${i}`]}|${user[`RacePoints${i}`]}|`;
            }
            csvText += `${user.totalPoints}|${user.position}\r\n`;
          });
          this.downloadCSV(csvText.replace(/&nbsp;/g, '').replace(/undefined/g, ''), "overall");
        } else {
          this.displayMrt = `assets/overall_result_${races.length}.mrt?random=${Math.random()}`;
          this.displayObj = object;
          this.displayPreview = true;
          this.cdr.markForCheck();
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getDifferenceInDays(date1: Date, date2: Date): number {
    const timeDiff = Math.abs(date2.getTime() - date1.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return diffDays;
  }

  // Загружает данные по кругам участника для сводного протокола
  getLapsData(user: DataOvervallReport, lapsData: OverallResultItem[]) {
    lapsData.map((lap, index) => {
      const num = index + 1;
      user[`RacePosition${num}`] = lap.place ? `${lap.place}&nbsp;&nbsp;` : '-&nbsp;&nbsp;';
      user[`RacePoints${num}`] = lap.scores ? `${lap.scores}&nbsp;&nbsp;` : '0&nbsp;&nbsp;';
    });
    return user;
  }

  downloadCSV(csvData: string, fileName: string = 'report') {
    // Добавляем BOM для UTF-8
    const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
    const blob = new Blob([bom, csvData], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}_${new Date().toISOString().replace(/[:]/g, '-')}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  //
  //
  //
  // -------------------------------   ЗАГРУЗКА РЕЗУЛЬТАТОВ ИЗ ФАЙЛА -----------------------------------------------------------------

  onFileSelect(event: any): void {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const fileContent: string = e.target.result.replace(/"/g, '').replace(/\r\n/g, '\n');
        const lines: string[] = fileContent.split('\n');
        let lineNum = 0;
        lines.forEach((line: string) => {
          const values: string[] = line.split(';');
          lineNum++;
          if (!line) {
            console.log(`${lineNum} - empty line, pass`);
            return;
          };
          const startNumber = values[0];
          if (startNumber) {
            const foundParticipant = (this.participants.find(participant => participant.startNumber === startNumber));
            if (foundParticipant) {
              let dnf = Number(values[1] || 0);
              let dnfComment = values[2];
              let penalty = Number(values[3] || 0);
              let penaltyComment = values[4];
              if (dnf || penalty) {
                this.progressService.saveDnfPenalty(penalty, penaltyComment, dnf, dnfComment, this.selectedRace.rUid, foundParticipant.clUid, foundParticipant.user.cUid);
              }
              let startTime = values[5];
              if (startTime) {
                if (!startTime.includes('.') && !startTime.includes('-')) startTime = `${this.selectedRace.date.getDate()}.${this.selectedRace.date.getMonth() + 1}.${this.selectedRace.date.getFullYear()} ${startTime}`;
                const startTimeMs = this.dateStringToMilliseconds(startTime);
                if (startTimeMs) {
                  const startTimeMsUtc0 = startTimeMs; // + (this.selectedRace.city.utcOffset * 60000);
                  this.progressService.saveStart(startTimeMsUtc0, this.selectedRace.rUid, foundParticipant.clUid, foundParticipant.user.cUid);
                  if (values.length > 5) {
                    for (let i = 6; i < values.length; i++) {
                      let lapEndTime = values[i];
                      if (lapEndTime) {
                        if (!lapEndTime.includes('.') && !lapEndTime.includes('-')) lapEndTime = `${this.selectedRace.date.getDate()}.${this.selectedRace.date.getMonth() + 1}.${this.selectedRace.date.getFullYear()} ${lapEndTime}`;
                        const lapEndTimeMs = this.dateStringToMilliseconds(lapEndTime);
                        if (lapEndTimeMs) {
                          const lapEndTimeMsUtc0 = lapEndTimeMs;
                          this.progressService.saveMark(0, lapEndTimeMsUtc0, this.selectedRace.rUid, foundParticipant.clUid, foundParticipant.user.cUid);
                        }
                      }
                    }
                  }
                }
                else this.messageService.add({ severity: 'error', summary: 'Error loading from file', detail: `Wrong start time in line ${lineNum}` });
              }
            } else {
              this.messageService.add({ severity: 'error', summary: 'Error loading from file', detail: `No such start number in competition: ${startNumber}` });
            }
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error loading from file', detail: `Wrong start number in file in line ${lineNum}` });
          }
        });
        event.target.value = '';
      };
      reader.onerror = () => {
        this.messageService.add({ severity: 'error', summary: 'File read error', detail: 'Could not read the file.' });
      };
      reader.readAsText(file);
    }
  }

  dateStringToMilliseconds(dateString: string): number | null {
    // 1. Проверяем формат строки
    // console.log(dateString);
    const isDotFormat = dateString.includes('.');
    const isDashFormat = dateString.includes('-');
    if (!isDotFormat && !isDashFormat) {
      console.error(`Invalid date string format. Expected 'DD.MM.YYYY HH:MM:SS' or 'YYYY-MM-DD HH:MM:SS', but got ${dateString}`);
      return null;
    }
    // 2. Разделяем строку на дату и время
    const [datePart, timePart] = dateString.split(' ');
    let year: number, month: number, day: number;
    // 3. Обрабатываем дату в зависимости от формата
    if (isDotFormat) {
      const [dayStr, monthStr, yearStr] = datePart.split('.');
      day = Number(dayStr);
      month = Number(monthStr);
      year = Number(yearStr);
    } else {
      const [yearStr, monthStr, dayStr] = datePart.split('-');
      year = Number(yearStr);
      month = Number(monthStr);
      day = Number(dayStr);
    }
    const [hours, minutes, seconds] = timePart.split(':').map(Number);

    const utcMs = Date.UTC(year, month - 1, day, hours, minutes, seconds) - (this.selectedRace.city.utcOffset * 60_000); //+ (new Date().getTimezoneOffset() * 60_000);
    // 8. Проверка валидности
    if (isNaN(utcMs)) {
      console.error('Invalid date after timezone adjustment');
      return null;
    }
    return utcMs;
  }

  //
  //
  //
  // -------------------------------   ПЕЧАТЬ ЗАЯВОК УЧАСТНИКОВ ---------------------------------------------------------------------

  // Открывает диалог выбора формы заявки при нажатии на кнопку Сформировать заявки (все) и формирует выбранный вариант
  selectApplicationFormForAll() {
    if (this.isStimulsoftLoading) {
      this.messageService.add({
        severity: 'info',
        summary: this.appSettings.translate[this.appSettings.selectedLang]['loadingDataReport'],
      });
      return;
    }
    this.selectApplicationForm().onClose.subscribe((variant: any) => {
      switch (variant.type) {
        case 'full':
          this.printApplicationFull(this.participants);
          break;
        case 'short':
          this.printApplicationShort(this.participants);
          break;
        case 'autosport_application':
          this.printApplicationAutosport(this.participants);
          break;
      }
    });
  }

  // Открывает диалог выбора формы заявки участника
  selectApplicationForm() {
    const loadingStimulsoft = (this.isStimulsoftLoading ? this.appSettings.translate[this.appSettings.selectedLang]['stimulsoft_loading'] : '');
    const variants = [
      {
        type: 'full',
        label: this.appSettings.translate[this.appSettings.selectedLang]['application_form_full'] + loadingStimulsoft,
        critical: false,
        disabled: this.isStimulsoftLoading,
      },
      {
        type: 'short',
        label: this.appSettings.translate[this.appSettings.selectedLang]['application_form_short'] + loadingStimulsoft,
        critical: false,
        disabled: this.isStimulsoftLoading,
      },
      {
        type: 'autosport_application',
        label: this.appSettings.translate[this.appSettings.selectedLang]['application_form_autosport'] + loadingStimulsoft,
        critical: false,
        disabled: this.isStimulsoftLoading,
      },

    ];

    return this.selectItemService.selectItem(
      this.appSettings.translate[this.appSettings.selectedLang]['select_application_form'],
      variants
    );
  }

  // Готовит данные для печати полной заявки участника
  getApplicationFullPrintData(participant: Registration) {
    const gpsTracker = `${participant.gpsTracker ? participant.gpsTracker : ''} ${participant.gpsTracker && participant.chronoTag ? '/' : ''
      } ${participant.chronoTag ? participant.chronoTag : ''}`;
    const object = {
      header: {
        city: this.selectedRace.city.address,
        userCity: participant.user.city,
        name_competition: this.selectedRace.name,
        start_number: participant.startNumber,
        motorcycle_class: participant.className,
        date: formatDate(this.selectedRace.date, this.format, 'ru-ru'),
        first_name: participant.user.name.split(' ')[1],
        second_name: participant.user.name.split(' ')[0],
        last_name: participant.user.name.split(' ')[2],
        team: participant.user.team,
        sportTitle: participant.user.sportTitle,
        citizenship: participant.user.citizenship,
        email: participant.user.email,
        insurance: '',
        insurance_date: '',
        phone: participant.user.phone ? `+${participant.user.phone}` : '',
        gpsTracker,
        leftImage: this.getImgSrc('protocolsLogoLeft'),
        centerImage: this.getImgSrc('protocolsLogoCenter'),
        rightImage: this.getImgSrc('protocolsLogoRight'),
        info: this.selectedRace.applicationText ? this.selectedRace.applicationText : this.appSettings.translate[this.appSettings.selectedLang]['info'],
        gender:
          participant.user.gender === 2
            ? this.appSettings.translate[this.appSettings.selectedLang]['female_short']
            : this.appSettings.translate[this.appSettings.selectedLang]['male_short'],
      },
      motorcycle_1: {
        brand: participant.info,
      },
    };

    if (participant.user.birthdate) {
      object.header['birthday_d'] = participant.user.birthdate.getDate();
      object.header['birthday_m'] = participant.user.birthdate.getMonth() + 1;
      object.header['birthday_y'] = participant.user.birthdate.getFullYear();
    }

    return object;
  }

  // Готовит данные для печати краткой заявки участника
  getApplicationShortPrintData(participant: Registration) {
    const object = {
      city: this.selectedRace.city.address,
      userCity: participant.user.city,
      name_competition: this.selectedRace.name,
      start_number: participant.startNumber,
      motorcycle_class: participant.className,
      date: formatDate(this.selectedRace.date, this.format, 'ru-ru'),
      first_name: participant.user.name.split(' ')[1],
      second_name: participant.user.name.split(' ')[0],
      last_name: participant.user.name.split(' ')[2],
      team: participant.user.team,
      insurance: '',
      insurance_date: '',
      phone: participant.user.phone ? `${participant.user.phone}` : '',
      gpsTracker: participant.gpsTracker,
      left_image: this.getImgSrc('protocolsLogoLeft'),
      center_image: this.getImgSrc('protocolsLogoCenter'),
      right_image: this.getImgSrc('protocolsLogoRight'),
      citizenship: participant.user.citizenship,
      email: participant.user.email,
      sportTitle: participant.user.sportTitle,
      info: this.selectedRace.applicationText ? this.selectedRace.applicationText : this.appSettings.translate[this.appSettings.selectedLang]['application_text'],
      motorcycle_1_brand: participant.info,
    };

    if (participant.user.birthdate) {
      object['birthday_d'] = participant.user.birthdate.getDate();
      object['birthday_m'] = participant.user.birthdate.getMonth() + 1;
      object['birthday_y'] = participant.user.birthdate.getFullYear();
    }

    return object;
  }

  // Формирует полную форму заявки участника
  printApplicationFull(participants: Registration[]) {
    // Готовим объект
    const racesData = participants.map((participant) => this.getApplicationFullPrintData(participant));

    this.messageService.add({
      severity: 'info',
      summary: this.appSettings.translate[this.appSettings.selectedLang]['loadingDataReport'],
    });

    this.displayObj = racesData;
    this.displayMrt = `assets/Report2_1.mrt?random=${Math.random()}`;
    this.displayPreview = true;
    this.cdr.markForCheck();
  }

  // Формирует краткую форму заявки участника
  printApplicationShort(participants: Registration[]) {
    // Готовим объект
    const racesData = {
      participants: participants.map((participant) => this.getApplicationShortPrintData(participant)),
    };

    this.messageService.add({
      severity: 'info',
      summary: this.appSettings.translate[this.appSettings.selectedLang]['loadingDataReport'],
    });

    this.displayObj = racesData;
    this.displayMrt = `assets/Report3_1.mrt?random=${Math.random()}`;
    this.displayPreview = true;
    this.cdr.markForCheck();
  }

  // Формирует форму заявки участника для автоспорта
  printApplicationAutosport(participants: Registration[]) {
    // Готовим объект
    const racesData = {
      participants: participants.map((participant) => this.getApplicationAutosportPrintData(participant)),
    };

    this.messageService.add({
      severity: 'info',
      summary: this.appSettings.translate[this.appSettings.selectedLang]['loadingDataReport'],
    });

    this.displayObj = racesData;
    this.displayMrt = `assets/ApplicationAutosport.mrt?random=${Math.random()}`;
    this.displayPreview = true;
    this.cdr.markForCheck();
  }

  getApplicationAutosportPrintData(participant: Registration) {
    const object = {
      name_competition: this.selectedRace.name,
      city: this.selectedRace.city.address,
      date: formatDate(this.selectedRace.date, this.format, 'ru-ru'),
      raсe_class: participant.className,
      start_number: participant.startNumber,
      first_name: participant.user.name.split(' ')[1],
      second_name: participant.user.name.split(' ')[2],
      last_name: participant.user.name.split(' ')[0],
      sht1_first_name: participant.crew && participant.crew[0] ? participant.crew[0].name.split(' ')[1] : '',
      sht1_second_name: participant.crew && participant.crew[0] ? participant.crew[0].name.split(' ')[2] : '',
      sht1_last_name: participant.crew && participant.crew[0] ? participant.crew[0].name.split(' ')[0] : '',
      sht2_first_name: participant.crew && participant.crew[1] ? participant.crew[1].name.split(' ')[1] : '',
      sht2_second_name: participant.crew && participant.crew[1] ? participant.crew[1].name.split(' ')[2] : '',
      sht2_last_name: participant.crew && participant.crew[1] ? participant.crew[1].name.split(' ')[0] : '',
      sht3_first_name: participant.crew && participant.crew[2] ? participant.crew[2].name.split(' ')[1] : '',
      sht3_second_name: participant.crew && participant.crew[2] ? participant.crew[2].name.split(' ')[2] : '',
      sht3_last_name: participant.crew && participant.crew[2] ? participant.crew[2].name.split(' ')[0] : '',
      userCity: participant.user.city,
      team: participant.user.team,
      phone: participant.user.phone ? `${participant.user.phone}` : '',
      gpsTracker: participant.gpsTracker,
      left_image: this.getImgSrc('protocolsLogoLeft'),
      center_image: this.getImgSrc('protocolsLogoCenter'),
      right_image: this.getImgSrc('protocolsLogoRight'),
      citizenship: participant.user.citizenship,
      email: participant.user.email,
      sportTitle: participant.user.sportTitle,
      info: this.selectedRace.applicationText ? this.selectedRace.applicationText : this.appSettings.translate[this.appSettings.selectedLang]['autosport_info'],
      auto_brand: participant.info,
    };

    if (participant.user.birthdate) {
      object['birthday_d'] = participant.user.birthdate.getDate();
      object['birthday_m'] = participant.user.birthdate.getMonth() + 1;
      object['birthday_y'] = participant.user.birthdate.getFullYear();
    }

    return object;
  }

  //
  //
  //
  // -------------------------------   ПЕЧАТЬ ТЕХКАРТ ---------------------------------------------------------------------

  // Печать техкарт участников выбранного класса или всех
  printAllTechCards() {
    // Готовим объект
    const racesData = {
      participants: this.participants.map((participant) => this.getTechCardPrintData(participant)),
    };

    this.messageService.add({
      severity: 'info',
      summary: this.appSettings.translate[this.appSettings.selectedLang]['loadingDataReport'],
    });

    // setTimeout(() => {
      this.displayPreview = true;
      this.displayObj = racesData;
      this.displayMrt = `assets/Report1.mrt?random=${Math.random()}`;
      this.cdr.markForCheck();
    // }, 1000);
  }

  // Печать техкарты выбранного участника
  printTechCard(participant: Registration) {
    // Готовим объект
    const racesData = { participants: this.getTechCardPrintData(participant) };

    this.messageService.add({
      severity: 'info',
      summary: this.appSettings.translate[this.appSettings.selectedLang]['loadingDataReport'],
    });
    this.displayPreview = true;
    this.displayObj = racesData;
    this.displayMrt = `assets/Report1.mrt?random=${Math.random()}`;
    this.cdr.markForCheck();
  }

  // Готовит данные для техкарты участника
  getTechCardPrintData(participant: Registration) {
    return {
      city: this.selectedRace.city.address,
      name_competition: this.selectedRace.name,
      start_number: participant.startNumber,
      motorcycle_class: participant.className,
      date: formatDate(this.selectedRace.date, this.format, 'ru-ru'),
      first_name: participant.user.name.split(' ')[0],
      second_name: participant.user.name.split(' ')[1],
      team_city: participant.user.team + ' / ' + participant.user.city,
      left_image: this.getImgSrc('protocolsLogoLeft'),
      center_image: this.getImgSrc('protocolsLogoCenter'),
      right_image: this.getImgSrc('protocolsLogoRight'),
      motorcycle_1_brand: participant.info,
    };
  }

  //
  //
  //
  // -------------------------------   ПЕЧАТЬ ЛИЦЕНЗИЙ МФР С ---------------------------------------------------------------------

  handleSportSubtypeSelected() {
    this.dialogSportSubType = false;
    if (this.participantToPrintLicense === null) this.printAllMfrLicense(); else this.printMfrLicense(this.participantToPrintLicense);
  }

  // Печать МФР лицензий участников выбранного класса или всех
  printAllMfrLicense() {
    const racesData = {
      participants: this.participants.map((participant) => this.getMfrLicensePrintData(participant)),
    };

    this.messageService.add({
      severity: 'info',
      summary: this.appSettings.translate[this.appSettings.selectedLang]['loadingDataReport'],
    });

    // setTimeout(() => {
      this.displayPreview = true;
      this.displayObj = racesData;
      this.displayMrt = `assets/report_mfr_license.mrt?random=${Math.random()}`;
      this.cdr.markForCheck();
    // }, 1000);
  }

  // Печать МФР лицензии выбранного участника
  printMfrLicense(participant: Registration) {
    const racesData = { participants: this.getMfrLicensePrintData(participant) };

    this.messageService.add({
      severity: 'info',
      summary: this.appSettings.translate[this.appSettings.selectedLang]['loadingDataReport'],
    });
    // setTimeout(() => {
      this.displayPreview = true;
      this.displayObj = racesData;
      this.displayMrt = `assets/report_mfr_license.mrt?random=${Math.random()}`;
      this.cdr.markForCheck();
    // }, 1000);
  }

  // Готовит данные для техкарты участника
  getMfrLicensePrintData(participant: Registration) {
    return {
      region: this.selectedRace.city.address.split(',')[1] ?? this.selectedRace.city.address,
      sport_subtype: this.sportSubType,
      surname: participant.user.name.split(' ')[0] ?? '',
      name: participant.user.name.split(' ')[1] ?? '',
      second_name: participant.user.name.split(' ')[2] ?? '',
      birthdate: formatDate(participant.user.birthdate, this.format, 'ru-ru'),
    };
  }

  //
  //
  //
  // -------------------------------   МЕНЮ ДЕЙСТВИЙ С УЧАСТНИКОМ ----------------------------------------------------------

  // Обрабатывает выбор из меню действий с участником
  onMenuOpen(registration: Registration) {
    this.selectMenuItem().onClose.subscribe((variant: any) => {
      if (variant) {
        switch (variant.type) {
          case 'full':
            this.printApplicationFull([registration]);
            break;
          case 'short':
            this.printApplicationShort([registration]);
            break;
          case 'autosport_application':
            this.printApplicationAutosport([registration]);
            break;
          case 'tech_card':
            this.printTechCard(registration);
            break;
          case 'mfr_license_c':
            this.dialogSportSubType = true;
            this.participantToPrintLicense = registration;
            break;
          case 'competitor_info':
            this.initModalForCompetitorInfo(registration);
            break;
          case 'delete_competitor':
            this.deleteCompetitor(registration);
            break;
        }
      }
    });
  }

  // Открывает меню действий с участником
  selectMenuItem() {
    const loadingStimulsoft = (this.isStimulsoftLoading ? this.appSettings.translate[this.appSettings.selectedLang]['stimulsoft_loading'] : '');
    const variants = [
      {
        type: 'full',
        label: this.appSettings.translate[this.appSettings.selectedLang]['application_form_full'] + loadingStimulsoft,
        critical: false,
        disabled: this.isStimulsoftLoading,
      },
      {
        type: 'short',
        label: this.appSettings.translate[this.appSettings.selectedLang]['application_form_short'] + loadingStimulsoft,
        critical: false,
        disabled: this.isStimulsoftLoading,
      },
      {
        type: 'autosport_application',
        label: this.appSettings.translate[this.appSettings.selectedLang]['application_form_autosport'] + loadingStimulsoft,
        critical: false,
        disabled: this.isStimulsoftLoading,
      },
      {
        type: 'tech_card',
        label: this.appSettings.translate[this.appSettings.selectedLang]['form_tech_card'] + loadingStimulsoft,
        critical: false,
        disabled: this.isStimulsoftLoading,
      },
      { type: 'competitor_info', label: this.appSettings.translate[this.appSettings.selectedLang]['competitor_info'], critical: false },
    ];
    if (this.selectedRace.sportType.code === '0910007511Я') {
      variants.push({
        type: 'mfr_license_c',
        label: this.appSettings.translate[this.appSettings.selectedLang]['mfr_license_c'],
        critical: false,
      });
    }
    if (this.filter !== 'deleted_reg')
      variants.push({
        type: 'delete_competitor',
        label: this.appSettings.translate[this.appSettings.selectedLang]['delete_competitor'],
        critical: true,
      });

    return this.selectItemService.selectItem(this.appSettings.translate[this.appSettings.selectedLang]['select_action'], variants);
  }

  // Добавить участника в класс
  addCompetitor() {
    this.addCompetitorDialog = true;
  }

  closeDialogEmit() {
    this.addCompetitorDialog = false;
  }

  // Удаляет регистрацию участника
  deleteCompetitor(participant: Registration) {
    this.commonService.confirm({
      message: this.appSettings.getTranslate('confirm_delete_competitor', [participant.user.name]),
      header: this.appSettings.translate[this.appSettings.selectedLang]['delete_competitor'],
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.progressService
          .deleteRegistration(this.selectedRace.rUid, participant.clUid, participant.user.cUid)
          .then(() => {
            this.refresh(this.selectedClass);
            this.messageService.add({
              severity: 'success',
              summary: this.appSettings.translate[this.appSettings.selectedLang]['success'],
              detail: this.appSettings.translate[this.appSettings.selectedLang]['deleted'],
            });
          })
          .catch((err) => {
            this.messageService.add({
              severity: 'error',
              summary: this.appSettings.translate[this.appSettings.selectedLang]['error'],
              detail: err.error.data !== '' ? err.error.data : err.message,
            });
          });
      },
      reject: () => { },
    });
  }

  //
  //
  //
  // -------------------------------   ПРОЧИЕ ФУНКЦИИ ---------------------------------------------------------------------

  // Формирует url для загрузки логотипов для протоколов
  getImgSrc(prop: string): string | null {
    if (this.selectedRace[prop]) {
      const url = `${this.appSettings.settings.urlFileDownload}/race/uid/${this.selectedRace[prop]}/view`;
      // const url = 'https://fget.portal6400.ru/fileserver/getfile?download=0&sid=cNItXje0X42dwZEv4BIrXX9B94AmOs7f&uid=953ab191-1884-433c-b5ac-43ea368a398d';
      // const url = 'https://fget.marshalone.ru/files/race/uid/dfbd5ae353d04028a555ed622e62d554/view';
      return url;
    }
    return null;
  }

  // Открывает форму для отметки возврата датчиков
  returnTag() {
    this.markReturnedSensorsService.openReturnSensorsDialog(this.selectedRace);
  }

  // Загрузка картинку логотипа для протоколов
  addAttachment(itemToAdd: CloudFile) {
    if (itemToAdd.file) {
      this.messageService.add({
        severity: 'success',
        summary: this.appSettings.getTranslate('loading_to_server', [itemToAdd.file.name]),
      });
      this.progressService.addRaceProtocolLogoAsAttachment(itemToAdd, this.selectedRace).then(() => {
        if (itemToAdd.file) {
          this.messageService.add({
            severity: 'success',
            summary: this.appSettings.getTranslate('image_added_to_selection', [itemToAdd.file.name]),
          });
        }
      });
    }
  }

  // Сохранение картинок логотипов для протоколов после их загрузки
  afterLogoImageSelected() {
    this.progressService.saveProtocolLogos(this.selectedRace);
  }

  // Закрывает печатную форму
  public clickPrintPreview() {
    this.displayPreview = false;
  }

  // Открывает / закрывает диалог формирования сводного протокола
  public clickSummaryStandingsDialog(value: boolean) {
    this.visibleOvervalResultDialog = value;
  }

  // Выдает список неудачных регистраций
  unsucessRegistrations(dateFrom: string = '', dateTo: string = '') {
    this.progressService.getUnsuccessRegistrations(this.selectedRace.rUid, dateFrom, dateTo).subscribe({
      next: (unsuccessRegistrations) => {
        this.unsuccessRegistrations = unsuccessRegistrations;
        unsuccessRegistrations[0].user.age.age;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  //
  //
  //
  // -------------------------------   ОТПРАВКА СМС ---------------------------------------------------------------------

  calculateSmsCount(): number {
    return this.smsText.length <= this.oneSmsLength ? 1 : Math.ceil(this.smsText.length / this.manySmsLength);
  }

  async sendSms(): Promise<void> {
    if (this.smsText == '') return;
    const participants = await this.progressService.getParticipants(
      this.selectedRace,
      this.selectedClass,
      false,
      this.competitorsListFilterSelector.getSelectedCompetitorsListFilter()
    );
    if (!participants) {
      return;
    }
    const participantCount = participants.length;
    const smsCount = this.calculateSmsCount();
    const costEstimate = participantCount * smsCount * this.smsPrice;
    const resultSmsLength = this.smsText.length <= this.oneSmsLength ? this.oneSmsLength : this.manySmsLength;

    this.commonService.confirm({
      message: this.appSettings.getTranslate('sms_confirm_query', [
        participantCount.toString(),
        this.smsText.length.toString(),
        resultSmsLength.toString(),
        smsCount.toString(),
        participantCount.toString(),
        smsCount.toString(),
        this.smsPrice.toString(),
        costEstimate.toString(),
        (participantCount * 1).toString(),
      ]),
      header: this.appSettings.translate[this.appSettings.selectedLang]['sms_confirm_header'],
      icon: 'pi pi-info-circle',
      accept: () => {
        this.progressService
          .sendSms(
            participants.map((participant) => {
              const phone = participant.user.phone;
              return phone.startsWith('+') ? phone.slice(1) : phone;
            }),
            this.smsText,
            this.selectedRace.rUid,
            true
          )
          .then((res) => {
            this.messageService.add({
              severity: 'success',
              summary: this.appSettings.translate[this.appSettings.selectedLang]['success'],
              detail: this.appSettings.translate[this.appSettings.selectedLang]['sms_sent'],
            });
          })
          .catch((err) => {
            this.messageService.add({
              severity: 'error',
              summary: this.appSettings.translate[this.appSettings.selectedLang]['error'],
              detail: this.appSettings.getTranslate('sms_not_sent', [
                err.status == 401
                  ? this.appSettings.translate[this.appSettings.selectedLang]['sms_forbidden']
                  : err.error.data !== ''
                    ? err.error.data
                    : err.message,
              ]),
            });
          });
      },
      reject: () => {
        this.messageService.add({
          severity: 'info',
          summary: this.appSettings.translate[this.appSettings.selectedLang]['calncel'],
          detail: this.appSettings.translate[this.appSettings.selectedLang]['sms_canceled'],
        });
      },
    });
  }

  //
  //
  //
  //  Модальки
  initModalForCompetitorInfo(registration: Registration) {
    this.getInfoCompInitiator.next(registration.user.cUid);
  }

  saveCompetitorInfo() {
    if (this.dataModalForCompetitorInfo) {
      this.patchInfoCompInitiator.next(this.dataModalForCompetitorInfo);
    }
  }

  // Подписываемся на получение инфо участника
  private subscribeToGet() {
    this.subscriptionGet = this.getInfoCompInitiator
      .pipe(
        switchMap((cUid) => {
          return this.progressService.getCompetitorInfo(cUid);
        })
      )
      .subscribe((info: CompetitorInfo) => {
        this.dataModalForCompetitorInfo = info;
        this.showModalForCompetitorInfo = true;
      });
  }

  // Подписываемся на обновление инфо участника
  private subscribeToPatch() {
    this.subscriptionGet = this.patchInfoCompInitiator
      .pipe(
        switchMap((info: CompetitorInfo) => {
          return this.progressService.patchCompetitorInfo(this.selectedRace.rUid, info.cUid, info.info);
        })
      )
      .subscribe(() => {
        this.showModalForCompetitorInfo = false;
      });
  }
}
